"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsTableEntry = void 0;
var date_fns_tz_1 = require("date-fns-tz");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var constants_1 = require("../../../../constants");
var copy_1 = require("../../../../copy");
var MeterReadingsTableEntry = function (_a) {
    var data = _a.data, isMobile = _a.isMobile, showRegisterLabel = _a.showRegisterLabel;
    var _b = (0, core_1.useComponents)(), TableCell = _b.TableCell, TableRow = _b.TableRow, Stack = _b.Stack;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if (isMobile) {
        return (react_1.default.createElement(TableRow, { key: data.readingDateTime.toISOString(), tabIndex: -1 },
            react_1.default.createElement(TableCell, null,
                react_1.default.createElement(Stack, { spaceBetween: 2 },
                    react_1.default.createElement("div", { "data-testid": "meter-readings-table_date" }, (0, date_fns_tz_1.format)(data.readingDateTime, constants_1.DATE_FORMAT)),
                    data.isMulti && data.register ? (react_1.default.createElement("div", { "data-testid": "meter-readings-table_meter-register" },
                        react_1.default.createElement(Copy, { copyKey: "historyTable".concat(data.register) }))) : null)),
            react_1.default.createElement(TableCell, null,
                react_1.default.createElement(Stack, { spaceBetween: 2 },
                    react_1.default.createElement("div", { "data-testid": "meter-readings-table_meter-reading" }, data.reading),
                    react_1.default.createElement("div", { "data-testid": "meter-readings-table_read_type" }, data.type)))));
    }
    return (react_1.default.createElement(TableRow, { key: data.readingDateTime.toISOString(), tabIndex: -1 },
        react_1.default.createElement(TableCell, null,
            react_1.default.createElement("span", { "data-testid": "meter-readings-table_date", title: (0, date_fns_tz_1.format)(data.readingDateTime, constants_1.SUPPLY_LOCAL_TIME_FORMAT) }, (0, date_fns_tz_1.format)(data.readingDateTime, 'd MMM yyyy'))),
        showRegisterLabel && data.register ? (react_1.default.createElement(TableCell, null,
            react_1.default.createElement("span", { "data-testid": "meter-readings-table_meter-register" },
                react_1.default.createElement(Copy, { copyKey: "historyTable".concat(data.register) })))) : null,
        react_1.default.createElement(TableCell, null,
            react_1.default.createElement("span", { "data-testid": "meter-readings-table_meter-reading" }, data.reading)),
        !isMobile && (react_1.default.createElement(TableCell, { "data-testid": "meter-readings-table_read_type" }, data.type))));
};
exports.MeterReadingsTableEntry = MeterReadingsTableEntry;
